if (!customElements.get('np-composition')) {
  customElements.define('np-composition', class extends HTMLElement {
    connectedCallback() {
      if(this.controller)return;
      this.controller=new AbortController();
      const {signal}=this.controller;
      this.buttons=[...this.querySelectorAll('[data-material]')];
      this.planes=[...this.querySelectorAll('[data-plane]')];
      this.graphics=[...this.querySelectorAll('.np-layer-graphic')];
      this.diagram=this.querySelector('.np-layer-diagram');
      this.toggle=this.querySelector('[data-composition-toggle]');
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
      this.animations=[];this.duration=10000;this.visible=false;this.userPaused=this.hasAttribute('data-focused');
      this.addEventListener('click',e=>{
        const toggle=e.target.closest('[data-composition-toggle]');
        if(toggle&&this.contains(toggle)){
          if(this.userPaused){this.userPaused=false;this.select(null);this.cancel();this.sync();}
          else this.pauseForReading();
          return;
        }
        const button=e.target.closest('[data-material]');
        if(!button||!this.contains(button))return;
        this.pauseForReading();
        this.select(button.getAttribute('aria-pressed')==='true'?null:button.dataset.material);
      },{signal});
      this.addEventListener('focusin',e=>{if(e.target.closest('[data-material]'))this.pauseForReading();},{signal});
      this.reduced.addEventListener('change',()=>this.sync(),{signal});
      document.addEventListener('visibilitychange',()=>this.sync(),{signal});
      if(this.diagram&&this.graphics.length){
        if('IntersectionObserver' in window){
          this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:0.08,rootMargin:'60px 0px'});
          this.observer.observe(this.diagram);
        }else this.visible=true;
        if('ResizeObserver' in window){
          this.resizeObserver=new ResizeObserver(entries=>{
            const {width,height}=entries[0].contentRect,size=`${Math.round(width)}x${Math.round(height)}`;
            if(this.size&&this.size!==size&&this.animations.length){
              const time=this.animations[0].currentTime||0;this.cancel();this.build(time);this.sync();
            }
            this.size=size;
          });
          this.resizeObserver.observe(this.diagram);
        }
      }
      this.sync();
    }
    select(active) {
      this.toggleAttribute('data-focused',Boolean(active));
      this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.material===active)));
      this.planes.forEach(p=>p.classList.toggle('is-active',p.dataset.plane===active));
    }
    build(time=0) {
      if(!this.diagram||!this.graphics.length||this.reduced.matches||this.userPaused)return;
      const box=this.diagram.getBoundingClientRect(),count=this.graphics.length;
      const spacing=innerWidth<=750?6:8;
      this.graphics.forEach((graphic,i)=>{
        const r=graphic.getBoundingClientRect(),closed=box.top+box.height/2+(i-(count-1)/2)*spacing-(r.top+r.height/2);
        const centered=box.left+box.width/2-(r.left+r.width/2),scale=Math.min(2.1,box.width*.66/r.width);
        const start=.08+i*.01,opened=.28+i*.01,closing=.73+(count-1-i)*.006,closedAt=.91+(count-1-i)*.006;
        const folded=`translate3d(${centered+(count-1-i)*.6}px,${closed}px,0) scale(${scale})`;
        graphic.style.zIndex=String(count-i);
        const options={duration:this.duration,iterations:Infinity,fill:'both',easing:'linear'};
        const graphicFrames=[
          {offset:0,transform:folded},{offset:start,transform:folded,easing:'cubic-bezier(.22,.72,.25,1)'},
          {offset:opened,transform:'translate3d(0,0,0) scale(1)'},{offset:closing,transform:'translate3d(0,0,0) scale(1)',easing:'cubic-bezier(.4,0,.2,1)'},
          {offset:closedAt,transform:folded},{offset:1,transform:folded}
        ];
        const labelFrames=[
          {offset:0,opacity:0,transform:'translate3d(16px,0,0)'},{offset:start+.04,opacity:0,transform:'translate3d(16px,0,0)',easing:'ease-out'},
          {offset:opened,opacity:1,transform:'translate3d(0,0,0)'},{offset:closing,opacity:1,transform:'translate3d(0,0,0)',easing:'ease-in'},
          {offset:Math.min(closedAt,closing+.12),opacity:0,transform:'translate3d(10px,0,0)'},{offset:1,opacity:0,transform:'translate3d(10px,0,0)'}
        ];
        const animations=[graphic.animate(graphicFrames,options),this.buttons[i].animate(labelFrames,options)];
        animations.forEach(a=>{a.pause();a.currentTime=time;this.animations.push(a);});
      });
    }
    cancel() {this.animations.forEach(a=>a.cancel());this.animations=[];}
    pauseForReading() {this.userPaused=true;this.cancel();this.sync();}
    sync() {
      const enabled=!!this.diagram&&!this.reduced.matches;
      if(this.toggle){
        this.toggle.hidden=!enabled;
        this.toggle.querySelector('[data-motion-label]').textContent=this.toggle.dataset[this.userPaused?'replay':'pause'];
        this.toggle.setAttribute('aria-label',this.toggle.dataset[this.userPaused?'replayLabel':'pauseLabel']);
        this.toggle.querySelector('[data-motion-pause]').toggleAttribute('hidden',this.userPaused);
        this.toggle.querySelector('[data-motion-replay]').toggleAttribute('hidden',!this.userPaused);
      }
      if(!enabled||this.userPaused){this.cancel();this.dataset.motion=enabled?'paused':'reduced';return;}
      const playing=this.visible&&document.visibilityState==='visible';
      if(playing&&!this.animations.length)this.build();
      this.animations.forEach(a=>{if(playing)a.play();else a.pause();});
      this.dataset.motion=playing?'playing':'offscreen';
    }
    disconnectedCallback() {
      this.controller?.abort();this.observer?.disconnect();this.resizeObserver?.disconnect();this.cancel();this.controller=null;
    }
  });
}
